import React from 'react';
import moment from 'moment';

import { CustomInput } from './CustomInput/CustomInput';
import { CustomHeader } from './CustomHeader/CustomHeader';
import { useDatePickerPresenter } from './DatePicker.presenter';
import { Wrapper, DatePickerStyled } from './DatePicker.styles';

const fn = () => {};

export const DatePicker = ({
  name = null,
  className = '',
  disabled = false,
  required = false,
  label = '',
  dateFormat = 'dd.MM.yyyy',
  onBlur = fn,
  error = '',
  value = '',
  minDate = new Date(),
  maxDate = new Date(moment(new Date().toISOString()).add(60, 'days').format('YYYY-MM-DD')),
  offset = [0, -6],
  autoFocus = true,
  dataTest,
  buttonDataTest,
  theme = 2,
}) => {
  const presenter = useDatePickerPresenter({
    value,
    minDate,
    maxDate,
    name,
    onBlur,
    disabled,
    autoFocus,
    offset,
  });

  return (
    <Wrapper
      required={error && required}
      disabled={disabled}
      className={className}
      focused={presenter.focused || !!presenter.innerValue}
    >
      <DatePickerStyled
        customInputRef={presenter.customInputRef}
        customInput={
          <CustomInput
            onChangeInput={presenter.inputChangeHandler}
            onBlurInput={presenter.blurHandler}
            innerValue={presenter.innerValue}
            disabled={disabled}
            ref={presenter.customInputRef}
            dataTest={dataTest}
            label={label}
            theme={theme}
            iconDataTest={buttonDataTest}
            error={error}
          />
        }
        renderCustomHeader={(p) => <CustomHeader selected={presenter.dateValue} {...p} />}
        focused={presenter.focused || !!presenter.innerValue}
        selected={presenter.dateValue}
        showPopperArrow={false}
        onSelect={presenter.selectHandler}
        dateFormat={dateFormat}
        minDate={minDate}
        maxDate={maxDate}
        popperPlacement="bottom-start"
        popperModifiers={presenter.popperModifiers}
        locale="ru"
        disabled={disabled}
      />
    </Wrapper>
  );
};
